module.exports = __webpack_public_path__ + "img/double-click.f191041c.svg";